import http from "utils/http";
import { user } from "constants/endpoints";

const deleteNotifyMeDashboardById = ({ idToDelete }) => {
  const ENDPOINT = user.deleteNotifyMeDashboardById();
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.delete(`${API_BASE_URL}${ENDPOINT}?idToDelete=${idToDelete}`);
};

export default deleteNotifyMeDashboardById;
